import store from '@/store/store';
/**
 * Check if token exist or not, if not redirect back to login page
 */
export default function auth({ next, router }) {
  const token = store.getters.getLoggedInUserToken;
  const businessId = store.getters.getLoggedInUserSelectedBusinessId;
  if (!token || !businessId) {
    return router.push({ name: 'Login' });
  }
  return next();
}
